import { render, staticRenderFns } from "./HTitle.vue?vue&type=template&id=1874752e&"
import script from "./HTitle.vue?vue&type=script&lang=js&"
export * from "./HTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports